import produce from 'immer'
import { useCallback, useMemo } from 'react'
import { Config } from 'src/types'

export type TPropsUseCapabilityToChangeUnitOnAllProducts = {
  config: Config
  setConfig: React.Dispatch<React.SetStateAction<Config>>
}

export default function useCapabilityToChangeUnitOnAllProducts({
  config,
  setConfig
}: TPropsUseCapabilityToChangeUnitOnAllProducts) {
  const changeUnitOnAllProducts = useCallback(
    (productName: string, productGroup: string, newUnit: string) => {
      setConfig(
        produce((draft: Config) => {
          draft.quays.forEach(quay => {
            quay.jetties.forEach(jetty => {
              jetty.products.forEach(product => {
                if (product.product === productName && product.productGroup === productGroup) {
                  product.productUnit = newUnit
                }
              })
            })
            quay.mobrus.forEach(mobru => {
              mobru.products.forEach(product => {
                if (product.product === productName && product.productGroup === productGroup) {
                  product.productUnit = newUnit
                }
              })
            })
          })
        })
      )
    },
    [setConfig]
  )

  return {
    changeUnitOnAllProducts
  }
}
